import { render } from "./SupplierEdit.vue?vue&type=template&id=4b4a1e56&scoped=true&ts=true"
import script from "./SupplierEdit.vue?vue&type=script&lang=ts"
export * from "./SupplierEdit.vue?vue&type=script&lang=ts"

import "./SupplierEdit.vue?vue&type=style&index=0&id=4b4a1e56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4a1e56"]])

export default __exports__